<template>
  <div class="quiz-contest-info">
    <div v-if="is_bind==1" class="container">
      <div class="header">
       
      </div>
      <el-table :data="tableData" style="width: 100%">
        
        <!-- <el-table-column prop="index" label="" width="180"> </el-table-column> -->
        
        <el-table-column prop="username" label="昵称" width="200"> </el-table-column>
        <el-table-column prop="avatar" label="头像" width="180">
          <img :src="scope.row.head_portrait" class="avatar" alt="" slot-scope="scope" />
        </el-table-column>
        <el-table-column label="院系" prop='department' width="180"></el-table-column>
        <!-- <el-table-column prop="index" label="名次" width="180"> </el-table-column> -->
        <el-table-column prop="answer_num" label="答题次数" width="180"> </el-table-column>
        <el-table-column prop="high_score" label="最高分数" width="180"> </el-table-column>
        <el-table-column prop="realname" label="姓名" width="200"> </el-table-column>
        <el-table-column prop="phone" label="联系方式" width="260"> </el-table-column>
        <!-- department -->
      </el-table>
      <div class="row">
        <div class="row-end">
          <button @click="prevPage" class="prev btn">上一页</button>
          <button @click="nextPage" class="next btn">下一页</button>
          <button @click="exportExcel" class="export btn ">导出表格</button>
        </div>
      </div>
    </div>
    <div v-else class="msg-box">
      <p class="msg-text">请通过审核后，查看答题竞赛信息！</p>
    </div>
  </div>
</template>

<script>
import { formToTime } from "@/utils/tools";
import store from '@/store/index.js';

const avatar_url = require("../../../../assets/img/avatar_reset.png");
export default {
  components: {},
  props: {},
  data() {
    return {
      storeData:store.state,

      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          avatar: `https://new.yulin365.net/attachment/images/2021/11/22/image_1637544608_YVzbkk8X.jpg`,
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          avatar: `https://new.yulin365.net/attachment/images/2021/11/22/image_1637544608_YVzbkk8X.jpg`,
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          avatar: `https://new.yulin365.net/attachment/images/2021/11/22/image_1637544608_YVzbkk8X.jpg`,
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          avatar: `https://new.yulin365.net/attachment/images/2021/11/22/image_1637544608_YVzbkk8X.jpg`,
        },
        {
          date: "2016-05-08",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          avatar: `https://new.yulin365.net/attachment/images/2021/11/22/image_1637544608_YVzbkk8X.jpg`,
        },
        {
          date: "2016-05-06",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          avatar: `https://new.yulin365.net/attachment/images/2021/11/22/image_1637544608_YVzbkk8X.jpg`,
        },
        {
          date: "2016-05-07",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
          avatar: `https://new.yulin365.net/attachment/images/2021/11/22/image_1637544608_YVzbkk8X.jpg`,
        },
      ],
      currentPage: 1,
    };
  },
  watch: {
    
  },
  computed: {
     is_bind(){
      if(this.storeData.adminInfo){
        return this.storeData.adminInfo.is_bind;
      }else{
        return ''
      }
    }
  },
  methods: {
    //   上一页
    previousPage() {
      //
    },
    //   下一页
    nextPage() {
      //
    },
    async getLibraryTopic() {
      try {
        const res = await this.$api.getLibraryTopic({
          params: {
            token: localStorage.getItem("admin-token"),
            page: this.currentPage,
          },
        });
        this.tableData = this.handleData(res.data.list);
        const total = 20 * (this.currentPage - 1) + res.data.list.length;
        this.hasNext = total < res.data.total_num ? true : false;
      } catch (error) {
        console.log("err", error);
      }
    },
    handleData(res) {
      res.forEach((item, index) => {
        // item.clock_time = 3800;
        // item.clock_time = formToTime(item.clock_time);
        item.index = index + 1 + (this.currentPage - 1) * 20;
        item.poster = item.poster ? item.poster : avatar_url;
      });
      return res;
    },
    nextPage() {
      if (this.hasNext) {
        this.currentPage++;
        this.getLibraryTopic();
      } else {
        this.$message.closeAll();
        this.$message({
          message: "已是最后一页了",
          type: "warning",
          offset:300,
            duration:2000
        });
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getLibraryTopic();
      } else {
        this.$message.closeAll();
        this.$message({
          message: "已是第一页了",
          type: "warning",
          offset:300,
            duration:2000
        });
      }
    },
    async exportExcel() {
      // /match/works/export-clock
      try {
        const elink = document.createElement("a");
        elink.style.display = "none";
        elink.href =
          "https://www.yulin365.net/api/v1/match/works/export-topic?token=" +
          localStorage.getItem("admin-token") +
          "&keywords=" +
          this.searchText +
          "&activity_id=" +
          this.activityId +
          "&status=" +
          this.status;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } catch (error) {
        console.error("err", error);
      }
    },
  },
  created() {
    this.getLibraryTopic();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.quiz-contest-info {
  margin: 40px 0;
  ::v-deep .has-gutter th {
    background-color: #f0eadd;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 20px;
    .labels {
      display: flex;
      border-radius: 5px;
      overflow: hidden;
      align-items: center;
      color: #999999;
      .label {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        height: 50px;
        padding: 0 20px;
        &:first-child {
          border-right: 1px solid #ddd;
        }
        .red {
          color: #815a4e;
          font-weight: bold;
          font-size: 18px;
        }
      }
    }
  }
  .row {
    padding-top: 30px;
    display: flex;
    justify-content: flex-end;
    .row-end {
      .btn {
        cursor: pointer;
        min-width: 100px;
        height: 40px;
        border-radius: 0;
        outline: none;
        border: 1px solid #999999;
        color: #815a4e;
        &:nth-child(1) {
          border-right: none;
        }
        &:nth-child(2) {
          border-right: none;
        }
        &.export {
          background-color: #815a4e;
          color: #fff;
        }
      }
    }
  }
  .msg-box {
    min-height: 50vh;
    .msg-text {
      color: #815a4e;
      font-size: 16px;
      margin-top: 40px;
    }
  }
}
</style>
